import { useEffect, useState } from 'react'
import { Button, Typography, Box, Stack } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { styled } from '@mui/material/styles'

const PaymentButton = styled(Button)({
  justifyContent: 'space-between',
  padding: '10px 20px',
  textTransform: 'none',
  borderRadius: '10px',
  boxShadow:
    '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  borderColor: '#dfdfdf',
  ':hover': {
    borderColor: '#969392 !important',
  },
})

type PaymentMethodComponentProps = {
  onSelectedChange: (value: any) => void
}

enum PaymentMethod {
  CreditCard = 'CreditCard',
  DuitNow = 'DuitNow',
}

export function PaymentMethodComponent({
  onSelectedChange,
}: Readonly<PaymentMethodComponentProps>) {
  const [selectedMethod, setSelectedMethod] = useState<PaymentMethod>(
    PaymentMethod.CreditCard,
  )

  const handleSelectMethod = (method: PaymentMethod) => {
    setSelectedMethod(method)
  }

  useEffect(() => {
    onSelectedChange(selectedMethod)
  }, [selectedMethod])

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h6" fontWeight="bold" color="#4D4D4D" mb={2}>
        Link Payment Method
      </Typography>

      <Stack direction="column" spacing={2}>
        {/* DuitNow Button */}
        <PaymentButton
          onClick={() => handleSelectMethod(PaymentMethod.DuitNow)}
          disabled
          variant="outlined"
          sx={{
            backgroundColor: selectedMethod === 'DuitNow' ? '' : 'transparent',
            borderColor:
              selectedMethod === 'DuitNow' ? '#969392 !important' : '#dfdfdf',
            borderWidth:
              selectedMethod === 'DuitNow' ? '3px !important' : '1px',
          }}>
          <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" alignItems="center" mb={1}>
              <Box
                component="img"
                src={require('../../../../assets/duitnow_logo.png')}
                sx={{ width: 30, height: 30, mr: 1 }}
              />
              <p className="font-bold">AutoDebit</p>
              <Box
                sx={{
                  border: '1px solid #dfdfdf',
                  borderRadius: 1,
                  px: 1,
                  ml: 1,
                  boxShadow: 1,
                }}>
                <p className="font-[200]">coming soon</p>
              </Box>
            </Box>
            <Box display="flex" alignItems="center">
              <p className="font-bold">supported banks:</p>
              <Box
                component="img"
                src={require('../../../../assets/uob.png')}
                sx={{ width: 45, ml: 2 }}
              />
              <Box
                component="img"
                src={require('../../../../assets/rhb.png')}
                sx={{ width: 45, ml: 1 }}
              />
            </Box>
          </Box>
          <ArrowForwardIosIcon style={{ color: 'black' }} />
        </PaymentButton>

        <Typography
          fontSize={12}
          fontStyle="italic"
          fontWeight={500}
          color="#979090"
          ml={2}>
          more banks available soon
        </Typography>

        {/* Credit/Debit Card Button */}
        <PaymentButton
          onClick={() => handleSelectMethod(PaymentMethod.CreditCard)}
          variant="outlined"
          sx={{
            backgroundColor:
              selectedMethod === 'CreditCard' ? '' : 'transparent',
            borderColor:
              selectedMethod === 'CreditCard'
                ? '#969392 !important'
                : '#dfdfdf',
            borderWidth:
              selectedMethod === 'CreditCard' ? '3px !important' : '1px',
          }}>
          <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Box
                component="img"
                src={require('../../../../assets/tng.png')}
                sx={{ width: 30, height: 20 }}
              />
              <Box
                component="img"
                src={require('../../../../assets/mastercard.png')}
                sx={{ width: 50, height: 40 }}
              />
              <Box
                component="img"
                src={require('../../../../assets/visa.png')}
                sx={{ width: 50, height: 40 }}
              />
              <Box
                component="img"
                src={require('../../../../assets/union.png')}
                sx={{ width: 30, height: 20 }}
              />
              <Box
                component="img"
                src={require('../../../../assets/amex.png')}
                sx={{ width: 30, height: 20 }}
              />
            </Box>
            <Box display="flex" gap={1}>
              <p className="font-bold">E-Wallet TNG or</p>
              <p className="font-bold">Credit / Debit Card</p>
            </Box>
          </Box>
          <ArrowForwardIosIcon style={{ color: 'black' }} />
        </PaymentButton>
      </Stack>
    </Box>
  )
}
